import WebRepository from '../web/WebRepository'
import Api from 'clients/web/Api'
import DateUtils from './DateUtils'
import PatientActivity from 'model/PatientActivity'
import moment from 'moment'

export class PatientActivityRepository extends WebRepository<PatientActivity> {
  constructor() {
    super(new Api('activity'))
  }

  async searchByDate(
    userId: any,
    startDate: moment.Moment | undefined,
    endDate: moment.Moment | undefined,
  ): Promise<PatientActivity[]> {
    let startTimeInSeconds = startDate!.valueOf() / 1000
    let endTime = endDate!.valueOf() / 1000
    let boundaries = []

    var isDayPeriod = moment(startDate).isSame(moment(endDate), 'day')

    for (var i = startTimeInSeconds; i <= endTime + 1; i += isDayPeriod ? 60 : 24 * 60 * 60)
      boundaries.push(i)

    return super.aggregateAll(
      {
        selector: [
          {
            $match: {
              patientId: userId,
              start_timestamp: {
                $gt: startDate?.unix(),
                $lt: endDate?.unix(),
              },
            },
          },
          {
            $bucket: {
              groupBy: '$start_timestamp',
              boundaries: boundaries,
              output: {
                sum: {
                  $sum: '$avg',
                },
                count: {
                  $sum: 1,
                },
              },
            },
          },
          {
            $addFields: {
              avg: {
                $divide: ['$sum', '$count'],
              },
              start_timestamp: '$_id',
            },
          },
          {
            $project: {
              sum: 0,
              count: 0,
              _id: 0,
            },
          },
        ],
      },
      (doc: any) => {
        return {
          start_timestamp: doc.start_timestamp,
          isDayPeriod: isDayPeriod,
          avg: doc.avg,
          steps: doc.avg,
        }
      },
    )
  }

  async search(userId: any): Promise<PatientActivity[]> {
    let startTimeInSeconds = DateUtils.getDaysAgoInSeconds(1)
    let minutes = new Date(startTimeInSeconds * 1000).getMinutes()
    if (minutes < 30) {
      minutes = 0
    } else {
      minutes = 30
    }

    startTimeInSeconds = Math.floor(
      new Date(startTimeInSeconds * 1000).setMinutes(minutes, 0, 0) / 1000,
    )

    let boundaries = []
    for (var i = startTimeInSeconds; i < new Date().getTime() / 1000 + 30 * 60; i += 30 * 60)
      boundaries.push(i)

    return super.aggregateAll(
      {
        selector: [
          {
            $match: {
              patientId: userId,
              start_timestamp: {
                $gt: startTimeInSeconds,
              },
            },
          },
          {
            $bucket: {
              groupBy: '$start_timestamp',
              boundaries: boundaries,
              output: {
                avg: {
                  $max: '$avg',
                },
              },
            },
          },
          {
            $addFields: {
              start_timestamp: '$_id',
            },
          },
          {
            $project: {
              _id: 0,
            },
          },
        ],
      },
      (doc: any) => {
        return {
          start_timestamp: doc.start_timestamp,
          steps: doc.avg,
        }
      },
    )
  }
}

export default new PatientActivityRepository()
